import {
  REACT_APP_APPLICATION_CODE,
  REACT_APP_API_BASE_URL,
} from "constants/index";

import { AuthenticationResult } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import axios from "axios";
import { LoginRequest } from "configs";
import { User, UserResponse } from "libs/auth";
import { restfulRequest } from "libs/axios";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import storage from "utils/storage";

export type LoginCredentialsDTO = {
  username?: string;
  password?: string;
  isOTP?: boolean;
  authData?: {
    email: string;
    code: number;
    csrfToken: string;
  };
};
export type LoginResponse = {
  login: UserResponse;
};

export const loginWithEmailAndPassword = async (
  input?: LoginCredentialsDTO
): Promise<UserResponse> => {
  const data = await restfulRequest()({
    url: "/auth/login",
    method: HTTPRequestMethods.POST,
    headers: {
      "x-application-code": REACT_APP_APPLICATION_CODE,
    },
    data: {
      provider: "password",
      authData: {
        email: input?.username,
        password: input?.password,
      },
    },
  });
  return data?.data?.data as UserResponse;
};

export const loginWithOTP = async (
  input?: LoginCredentialsDTO
): Promise<UserResponse> => {
  const data = await restfulRequest()({
    url: "/auth/login",
    method: HTTPRequestMethods.POST,
    headers: {
      "x-application-code": REACT_APP_APPLICATION_CODE,
    },
    data: {
      provider: "otp",
      authData: input?.authData,
    },
  });
  return data?.data?.data as UserResponse;
};

export const loginTSM = async (): Promise<any> => {
  const token = storage.getToken();
  const dataLogin = await axios.post(
    "/login-tsm",
    {
      token,
    },
    {
      baseURL: REACT_APP_API_BASE_URL,
    }
  );
  return { user: dataLogin.data as User, accessToken: token } as UserResponse;
};

export const signinTSM = async (res: AuthenticationResult) => {
  return restfulRequest()({
    url: "/auth/login",
    method: HTTPRequestMethods.POST,
    data: {
      provider: "azure",
      authData: {
        accessToken: res?.accessToken,
        idToken: res?.idToken,
        oid: (res?.idTokenClaims as { oid: string })?.oid,
      },
    },
  });
};

export const useLoginViaAzureFn = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  const loginViaAzure = async () => instance.loginRedirect(LoginRequest);

  return {
    loginViaAzure,
  };
};
